import { createTheme, responsiveFontSizes } from "@mui/material/styles";

import { Palette } from "./Palette";
import { Typography } from "./Typography";
import { Styles } from "./Styles";

const baseTheme = createTheme({
  palette: Palette,
  typography: Typography,
  components: Styles,
});

const theme = responsiveFontSizes(baseTheme);

export default theme;
